import React, { Component } from 'react';
import styled from 'styled-components';

import { FaBullhorn } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistoryPush } from '../../../services/hooks/UseHistoryPush';

import List from '../../List';

import { StyledBriefingsList } from './style/StyledBriefingsList';
import { ContentTitle } from '../../utilities/styledComponents/ContentTitle';

const ContextText = styled.div`
  font-family: Poppins, Heltica, Arial, sans-serif;
  color: #8E8E8E;
  font-size: 1.6em;
  margin: 20px 0;
`;

export default class BriefingsList extends Component {
	state = {
		dataNewsBriefings: [],
		dataOldBriefings: [],
		loading: true,
	};

	componentDidMount() {
		api.get('/briefings')
			.then((response) => {
				this.setState({ loading: false }, () => this.filterDataBriefings(response.data.data));
			});
	}

	filterDataBriefings = (data) => {
		const { dataNewsBriefings, dataOldBriefings } = this.state;

		data.map((briefing) => {
			if (briefing.status === 1 || briefing.status === 3) {
				dataNewsBriefings.push(briefing);
				return this.setState(dataNewsBriefings);
			}

			dataOldBriefings.push(briefing);
			return this.setState(dataOldBriefings);
		});
	};

	buttonClick = (briefing) => {
		const { dataOldBriefings } = this.state;
		const briefingStatus = parseInt(briefing.status, 10);

		if (briefingStatus === 1 && dataOldBriefings.length > 0) {
			return useHistoryPush('/briefing/clonar', { briefingId: briefing.id, briefing });
		}
		return useHistoryPush('/briefing', { briefingId: briefing.id, briefing });
	};

	render() {
		const { dataNewsBriefings, dataOldBriefings, loading } = this.state;

		return (
			<StyledBriefingsList>
				<div className="position-relative">
					<div className="content-general">
						<article>
							<div>
								<ContentTitle>Bem-vindo ao Gearbox</ContentTitle>

								<div className="content-briefings">
									<div className="box-briefing briefings">
										<div className="title">
											<FaBullhorn />
											<h4>Briefings</h4>
										</div>

										<ContextText>
											<p>
												O briefing é um conjunto de respostas que nos dirá exatamente como realizar
												sua campanha. É importante dedicar uma atenção especial ao preenchimento
												desse questionário, pois é através dessas informações que os especialistas
												Gearbox desenvolverão sua campanha. Quanto mais informações de qualidade,
												melhores serão os resultados! Portanto, capriche! :)
											</p>
										</ContextText>
									</div>

									<div className="box-briefing news-briefings">
										<div className="title">
											<FaBullhorn />
											<h4>Novos briefings</h4>
										</div>

										<div className="table-responsive">
											<List
												loading={loading}
												dataThead={['Pré venda:', 'Data:', 'Valor:', 'Duração:', 'Combo:', '']}
												dataTbody={dataNewsBriefings}
												button={{ classButton: 'btn-danger', value: 'PREENCHER BRIEFING', onClick: this.buttonClick }}
											/>
										</div>
									</div>

									<div className="box-briefing old-briefings mb-0">
										<div className="title">
											<FaBullhorn />
											<h4>Briefings de antigas campanhas</h4>
										</div>

										<div className="table-responsive">
											<List
												loading={loading}
												dataThead={['Pré venda:', 'Data Pré Venda:', 'Data Preenchimento:', 'Valor:', 'Duração:', 'Combo:', '']}
												dataTbody={dataOldBriefings}
												button={{ classButton: 'btn-simple', value: 'VISUALIZAR BRIEFING', onClick: briefing => useHistoryPush(`/briefings/${briefing.id}/detalhes/1`) }}
											/>
										</div>
									</div>
								</div>
							</div>
						</article>
					</div>
				</div>
			</StyledBriefingsList>
		);
	}
}
